module.exports = __webpack_public_path__ + "static/media/prepaid-empty-shopping-cart.e65508b7.svg";